var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.uiTexts && _vm.uiConfig)?_c('v-footer',[_c('v-col',{staticClass:"text-center"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.uiConfig.aboutText)}}),_c('br'),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.uiConfig.poweredByText)}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }